import jQuery from 'jquery';
import validate from 'jquery-validation';
import 'jquery-validation-unobtrusive';

// define $ and jQuery on the global window object
Object.assign(jQuery, { validate });
Object.assign(window, { $: jQuery, jQuery });
